import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Stack,
  TextField,
} from "@mui/material";
import type { AccountUserRole } from "@/domain/model/AccountSeatOverview";
import { humanizeRole } from "../UiLabels";

const ROLE_OPTIONS: AccountUserRole[] = ["WORKER", "ADMIN"];

export function InviteUserDialog(props: {
  open: boolean;
  email: string;
  role: AccountUserRole;
  isBusy: boolean;
  onClose: () => void;
  onEmailChange: (value: string) => void;
  onRoleChange: (value: AccountUserRole) => void;
  onSubmit: () => void;
}) {
  return (
    <Dialog
      open={props.open}
      onClose={props.isBusy ? undefined : props.onClose}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>App-Nutzer einladen</DialogTitle>

      <DialogContent>
        <Stack spacing={2} sx={{ pt: 1 }}>
          <TextField
            label="E-Mail"
            type="email"
            value={props.email}
            onChange={(event) => props.onEmailChange(event.target.value)}
            fullWidth
            autoFocus
          />

          <TextField
            label="Rolle"
            select
            value={props.role}
            onChange={(event) =>
              props.onRoleChange(event.target.value as AccountUserRole)
            }
            fullWidth
          >
            {ROLE_OPTIONS.map((role) => (
              <MenuItem key={role} value={role}>
                {humanizeRole(role)}
              </MenuItem>
            ))}
          </TextField>
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={props.onClose} disabled={props.isBusy}>
          Abbrechen
        </Button>

        <Button
          variant="contained"
          onClick={props.onSubmit}
          disabled={props.isBusy}
        >
          {props.isBusy ? "Wird erstellt …" : "Einladen"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
